import { SipRecommendationActionType } from '../../api/common.types'
import type { SipPlanRecommendationContainerInput } from '../open/planRecommendationOpen'
import { useSipPlanRecommendation } from '../useSipPlanRecommendation'
import { SipIncreasePlanRecommendationSheet } from './SipIncreasePlanRecommendationSheet'

export function SipIncreasePlanRecommendationContainer(input: SipPlanRecommendationContainerInput) {
  const { onDismiss, isin, totalIdealSipAmount, recommendation, initiateSipCta } = input
  const { planDetails, isLoading, isFetchFailed, onRetry } = useSipPlanRecommendation(
    isin,
    SipRecommendationActionType.INCREASE,
    totalIdealSipAmount,
    true
  )

  return (
    <SipIncreasePlanRecommendationSheet
      onDismiss={onDismiss}
      planDetails={planDetails}
      isLoading={isLoading}
      isFetchFailed={isFetchFailed}
      onRetry={onRetry}
      recommendation={recommendation}
      initiateSipCta={initiateSipCta}
    />
  )
}
